var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBackBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.743164 6.04395C0.743164 6.31055 0.859375 6.59082 1.04395 6.77539L5.50098 11.2188C5.70605 11.4238 5.95215 11.5264 6.19141 11.5264C6.77246 11.5264 7.16895 11.123 7.16895 10.5898C7.16895 10.2959 7.03906 10.0566 6.85449 9.87891L5.32324 8.34766L3.80566 6.95312L5.30273 7.03516H13.0273C13.6426 7.03516 14.0527 6.63184 14.0527 6.04395C14.0527 5.44922 13.6426 5.05273 13.0273 5.05273H5.30273L3.8125 5.13477L5.32324 3.74023L6.85449 2.20215C7.03906 2.02441 7.16895 1.79199 7.16895 1.49121C7.16895 0.958008 6.77246 0.554688 6.19141 0.554688C5.95215 0.554688 5.70605 0.657227 5.49414 0.869141L1.04395 5.3125C0.859375 5.49707 0.743164 5.77734 0.743164 6.04395Z",
    fill: "#21FFEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackBlue);
export default __webpack_public_path__ + "static/media/arrow-back-blue.bb5caf32a870746d075c3026d01ec8ef.svg";
export { ForwardRef as ReactComponent };